mutation ArchiveCustomField($input: DeleteCustomFieldInput!) {
    deleteCustomField(input: $input) {
        customField {
            id
        }
    }
}
